import { actions } from '../constants/calendar';
import * as actionTypes from '../../models/action/calendar';

export function GetCalendarData(startDate: any, endDate: any, filter: actionTypes.IFilter, spinnerId?: string, spinnerType?: 'get' | 'set') : actionTypes.IGetCalendarDatas {
    return{
        startDate,
        endDate,
        filter,
        type: actions.GET_CALENDAR_DATAS,
        timestamp: Date.now(),
        spinnerId,
        spinnerType
    };
}

export function SetCalendarData(calendarDatas: actionTypes.ICalendarData[], spinnerId?: string, spinnerType?: 'get' | 'set') : actionTypes.ISetCalendarDatas {
    return{
        calendarDatas,
        type: actions.SET_CALENDAR_DATAS,
        timestamp: Date.now(),
        spinnerId,
        spinnerType
    };
}